import script from "./TheQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./TheQuestion.vue?vue&type=script&setup=true&lang=js"

import "./TheQuestion.vue?vue&type=style&index=0&id=6355a48d&scoped=true&lang=css"

import exportComponent from "F:\\.openserver\\OpenServer\\domains\\geo_exams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6355a48d"]])

export default __exports__